import type { TransferIdBuf } from "~/classes/generated/status"

import { parseUuidBuf } from "./id"

export function parseTransferId(buf: TransferIdBuf) {
  const key = parseUuidBuf(buf.id()!)
  return key.toString()
}
